"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransformPlacesData = exports.ExtractNamePieces = void 0;
const TransformPlacesData = placeData => {
  // eslint-disable-next-line camelcase
  const {
    address_components,
    name
  } = placeData;
  const extractBasedOnType = (placeDataType, useShortName) => {
    // eslint-disable-next-line camelcase
    const data = address_components.find(component => component.types.indexOf(placeDataType) !== -1);
    if (useShortName) {
      return data.short_name || '';
    }
    return data.long_name || '';
  };
  const subPremise = extractBasedOnType('subpremise');
  const streetNumber = extractBasedOnType('street_number');
  const streetName = extractBasedOnType('route');
  const address = "".concat(subPremise ? "".concat(subPremise, "/") : '').concat(streetNumber ? "".concat(streetNumber, " ") : '').concat(streetName ? "".concat(streetName, " ") : '');
  const suburb = extractBasedOnType('locality');
  const state = extractBasedOnType('administrative_area_level_1', true);
  const country = extractBasedOnType('country', true);
  const postcode = extractBasedOnType('postal_code');
  return {
    name,
    address,
    suburb,
    state,
    postcode,
    country
  };
};
exports.TransformPlacesData = TransformPlacesData;
const ExtractNamePieces = name => {
  const posSpaceName = name.lastIndexOf(' ');
  const posDotName = name.lastIndexOf('.');
  const posUnderscoreName = name.lastIndexOf('_');
  if (posSpaceName === -1) {
    // Auth0 is using the email address for both so try and derive from the Name
    if (posDotName !== -1) {
      return {
        firstName: name.substring(0, posDotName),
        lastName: name.substring(posDotName + 1)
      };
    }
    if (posUnderscoreName !== -1) {
      return {
        firstName: name.substring(0, posUnderscoreName),
        lastName: name.substring(posUnderscoreName + 1)
      };
    }
  }
  return {
    firstName: name.substring(0, posSpaceName),
    lastName: name.substring(posSpaceName + 1)
  };
};
exports.ExtractNamePieces = ExtractNamePieces;